module.exports = __webpack_public_path__ + "img/query-new-9.fa473dbc.png";